import { ISearch } from './ISearch.model';
import { ActionPlanModel } from './action-plan.model';
import { ActionPlanItem } from './action-plan-item.model';

export class ActionPlanPlugin implements ISearch {
  public config: any = {};
  public actionPlan: ActionPlanModel;
  public actionPlanItem: ActionPlanItem;
  public code: string;
  public actionPlanId: string;
  public actionPlanItemId: string;

  constructor(public id: string, public order: number, public pluginType: string) {}

  public search(query: string): boolean {
    let queryToLower = query.toLowerCase();
    return this.pluginType == null || this.pluginType.toLowerCase().indexOf(queryToLower) !== -1;
  }
}
